import { APP_MALFUNCTIONS } from '@ngb-frontend/shared/config'

import type { MalfunctionCode } from '@ngb-frontend/shared/types'

export const isMalfunction = (x: unknown): x is MalfunctionCode => {
  return (
    typeof x === 'string' && APP_MALFUNCTIONS.includes(x as MalfunctionCode)
  )
}
